import { Navigate } from "react-router-dom";
import { FEATURES } from "@/config/features";

interface FeatureRouteProps {
  featureKey: keyof typeof FEATURES;
  children: React.ReactNode;
}

const FeatureRoute = ({ featureKey, children }: FeatureRouteProps) => {
  if (!FEATURES[featureKey]) {
    return <Navigate to="/explore" replace />;
  }
  return <>{children}</>;
};

export default FeatureRoute;
